import { StatisticProps } from 'antd';
import { IglooTypographyProps } from 'iglooform/es/typography';
import Amount from '@/components/amount';
import styles from './index.less';

interface Props extends StatisticProps {
  unit?: string;
  amount: number;
  level?: IglooTypographyProps['level'];
}

export default ({ unit, ...rest }: Props) => {
  return (
    <div className={styles.wrapper}>
      {unit && <span className={styles.unit}>{unit}</span>}
      <Amount {...rest} />
    </div>
  );
};
